export const GET_TASKS_SUCCESS = '[DASHBOARD][FETCH][TASKS] success get tasks';
export const GET_TASK_PROFILE_SUCCESS = '[FETCH][TASKS] success get task profile';
export const LOADING_TASKS = '[DASHBOARD][LOADING][TASKS] set loading tasks';
export const CLEAR_DETAILS = '[TASKS] clear detail';
export const SET_SHOW_PROFILE_ICONNAME_STATE = '[TASKS] set profile icon name visibility';
const json = {
  GET_TASKS_SUCCESS,
  GET_TASK_PROFILE_SUCCESS,
  LOADING_TASKS,
  CLEAR_DETAILS,
};

export default json;
